import axios from "axios";

const api = axios.create({
  baseURL: "https://webhook.aeontechhub.com/",
  // baseURL: "https://www.tmtuerp.in/BK_WAGLE",
  // baseURL: "http://180.179.170.200:9092/",
});

// api.interceptors.response.use(
//   (response) => response, // Pass successful responses
//   (error) => {
//     if (error.response && error.response.status === 401) {
//       console.warn("Unauthorized! Clearing session...");

//       localStorage.clear();
//       window.location.href = "/";
//     }

//     return Promise.reject(error);
//   }
// );

export default api;
